export function toJsonString(jsonObject: any): string {
    if (!jsonObject) {
        return '';
    }

    return JSON.stringify(jsonObject, undefined, 2);
}
